export const BOOKING_METHODS = {
  instant: 'instant',
  poll: 'poll',
}

export const MAX_SELECTED_POLL_SPOTS = 40
export const MAX_RANGE_BETWEEN_SPOTS = 3
export const FETCHED_EVENTS_DAYS_RANGE = 7

export const DATE_FORMAT = 'YYYY-MM-DD'

export const emptySpotsError = 'empty_spots'
export const noHostsSelectedError = 'no_hosts'
export const maxRangeExceededError = 'max_range_exceeded'
export const maxPollSpotsReachedError = 'max_poll_spots_reached'

export const TYPE_INTERNAL = 'internal'
export const TYPE_EXTERNAL = 'external'
